import { render } from "./confirmPhone.vue?vue&type=template&id=e19f0c20&scoped=true"
import script from "./confirmPhone.vue?vue&type=script&lang=js"
export * from "./confirmPhone.vue?vue&type=script&lang=js"

import "./confirmPhone.vue?vue&type=style&index=0&id=e19f0c20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e19f0c20"]])

export default __exports__